import create from '~/misc/create';
import types from './types';
import {addMyCompanies, companyBroker} from '~/api/company';
// import {type} from 'os';


export const addCompany = (data) => (dispatch, getState) => new Promise((resolve, reject) => {
  addMyCompanies(getState, data)
    .then(response => {
      const payload = {[data]: response.data};
      dispatch(create(types.ADD_MY_COMPANY, payload));
      resolve(response);
    }).catch(error => {
      // const payload = [];
      // dispatch(create(types.ADD_MY_COMPANY, payload))
      reject(error);
    });
});
// 清空本地broker
export const emptyCompany = () => (dispatch) => {
  dispatch(create(types.EMPTY_MY_COMPANY));
};
// 删除一个broker
export const removeCompany = (data) => (dispatch, getState) => {
  companyBroker(getState, {id: data.id, operate: 'remove'})
    .then((response) => {
      if (response.code !== 500) {
        const payload = {id: data.id, brokerType: data.type};
        dispatch(create(types.REMOVE_MY_COMPANY, payload));
      }
    });
};



// WEBPACK FOOTER //
// ./src/modules/myCompany/actions.js